<template>
  <div>
    <tile-card showDeleteOption showDownloadOption
      :onClickEmitEvent="false"
      :icon="icon"
      :iconColor="'primary'"
      :title="file.title"
      :subtitle="subtitle"
      :border-radius="'10px'"
      :titleStyle="'font-size: 16px; font-weight: bold'"
      :textOnMouseOver="file.title"
      :backgroundColor="'white'"
      :contentPadding="'px-10'"
      :processing="showProgressCircular"
      @deletion="setDeletionDialog(true)"
      @download="openURL"
    />

    <deletion-dialog v-if="deletionDialog"
      :title="'Exclusão'"
      :enabled="deletionDialog"
      :dialogColor="'error'"
      :confirmationButtonColor="'error'"
      :confirmationButtonMessage="'Excluir'"
      :confirmationMessage="'Você tem certeza que deseja excluir o arquivo? Ele não será mais acessível.'"
      @abort="setDeletionDialog(false)"
      @confirm="deleteFile"
    />
  </div>
</template>

<script>
import TileCard from '@/components/TileCard.vue';
import DeletionDialog from '@/components/templates/ConfirmationDialog'
import cardTypes from './cardTypes'

export default {
  components: { TileCard, DeletionDialog },

  props: {
    file: { type: Object, required: true, },
    deletingFile: { required: true, },
  },

  data: () => ({ 
    cardTypes,
    deletionDialog: false,
  }),

  methods: {
    openURL() {
      window.open(this.file.url);
    },
    setDeletionDialog(state) {
      this.deletionDialog = state
    },
    deleteFile() {
      this.$emit('deletion', this.file)
      this.setDeletionDialog(false)
    },
  },

  computed: {

    showProgressCircular() {
      const { deletingFile, file } = this
      return deletingFile ? deletingFile.title === file.title : false
    },
    cardType() {
      const filter = file => file.mimeType === this.file.mimeType 
      const filteredType = this.cardTypes.filter(filter)[0];
      return filteredType || this.cardTypes[0];
    },
    icon() {
      return this.cardType.icon;
    },
    subtitle() {
      return this.cardType.subtitle;
    },
  },
};
</script>
